import { SiteLayout } from '../components/site/SiteLayout';
import { DualBooking } from '../components/site/DualBooking';

export default function Appointment() {
  return (
    <SiteLayout testid="appointment-page">
      <DualBooking testid="appointment-booking" title="Schedule your free consultation" />
    </SiteLayout>
  );
}
